
export default {
  mainContainer: {
    height: "calc(94vh - 115px)",
    overflowY: "auto",
    display: "flex",
    justifyContent: "space-between",
    backgroundColor: "white",
  },
  topCard: {
    borderRadius: 0,
    padding: '0 16px 0 0 !important',
  },
  cardTitle: {
    // borderRadius: 0,
  },
  topCardContainer: {
    margin: "10px",
  },
  topCardContainer2: {
    position: "fixed",
    marginLeft: "26vw",
    height: "8vh",
    backgroundColor: "white",
  },
  topCardContainer3: {
    position: "fixed",
    marginLeft: "48vw",
    height: "8vh",
    backgroundColor: "white",
  },
  tableContainer: {
    position: "relative",
    width: "100%",
    height: "100%",
    padding: "0px 10px 0px 10px",
    overflow: "auto",
    boxSizing: "border-box",
  },
  // tableContainerSmallDevices: {

  //   position: "relative",
  //   width: "100%",
  //   height: "100%",
  //   padding: "0px 10px 0px 10px",
  //   overflow: "auto",
  //   boxSizing: "border-box",
  // },
  leftContainer: {
    width: "100%",
    overflow: "auto",
    height: "100%",
    display: "flex",
    flexDirection: "column",
    backgroundColor: "white",
    paddingTop: "20px",
    boxSizing: "border-box",
  },
  textContainer: {
    width: "100%",
    padding: "0 25px",
    fontSize: "12px",
    color: "rgb(50, 50, 50)"
  },
  activeButton: {
    backgroundColor: "#019934",
    color: "#fff",
    fontSize: "0.75em",
    fontWeight: "bold",
    margin: "auto",
  },
  inactiveButton: {
    backgroundColor: "white",
    color: "#000",
    fontSize: "0.75em",
    fontWeight: "normal",
    margin: "auto",
  },
  rightContainer: {
    overflowY: "auto",
    height: "100%",
    padding: "25px",
    backgroundColor: "#D3D3D3",
    boxSizing: "border-box",
  },
  stockPaper: {
    padding: 10,
  },
  paginationContainer: {
    position: "fixed",
  },

  rightNews: {},
  articlesFixed: {
    overflow: "auto",
    backgroundColor: "white",
    height: "calc(100% - 310px)",
    fontSize: "0.85rem",
  },
  articlesTitleFixed: {},
  newsContainer: {
    height: "4rem",
    overflow: "hidden",
    backgroundColor: "white",
    marginRight: "15px",
    padding: "0.2rem",
  },
  leftNewsPic: {
    width: "35%",
    float: "left",
    margin: "5px",
  },
  headerCell: {
    textColor: "black",
    fontWeight: "bold",
    padding: "0 5px",
    borderRight: "1px solid #e0e0e0",
    backgroundColor: "#bababa",
    top: "45px",
    fontSize: "0.875rem",
  },
  headerCellMobile: {
    textColor: "white",
    padding: "0px",
    borderRight: "1px solid #e0e0e0",
    borderBottom: "1px solid #e0e0e0",
  },
  selectstock: {
    color: "white",
    backgroundColor: "#700606",
    padding: "3px 0px",
    textAlign: "center",
    fontSize: "0.875rem",
    borderTop: "2px gray solid",
  },
  removeUnderline: { textDecoration: "none", color: 'rgb(0 0 0 / 87%)', padding: '5px 28px' },
  clickableCell: {
    fontSize: 12,
    padding: 0,
    opacity: 1,
    borderRight: "1px solid #e0e0e0",
    // width: cellWidth,
    background: "rgba(95, 105, 175, 0.5)",
    textAlign: 'center',
    cursor: 'pointer'
  },
  rowCell: {
    height: "24px",
    padding: "0px 5px",
    fontSize: "0.75em",
    borderRight: "1px solid #e0e0e0",
    borderBottom: "1px solid #e0e0e0",
  },
  Modal: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    height: '83%',
    width: '50%',
    backgroundColor: 'white',
    padding: '5px',
    overflowY: 'auto'
  },
  headerCellEdge: {
    top: "27px",
    textColor: "black",
    fontWeight: "bold",
    padding: "0px 10px",
    borderRight: "1px solid black",
    backgroundColor: "#bababa",
    fontSize: "0.875rem",
  },
  rowCellEdge: {
    height: "24px",
    padding: "0px 10px",
    borderBottom: "1px solid #e0e0e0",
    borderRight: "1px solid black",
  },
  calenderStyle: {
    backgroundColor: "#13639c",
    color: "white",
    fontWeight: "bold",
    textAlign: "start",
    borderRight: "1px solid black",
    boxShadow: "inset rgb(0, 0, 0) 0px -1px 0px",
    top: "0px",
  },
  stockStyle: {
    backgroundColor: "#13639c",
    color: "white",
    fontWeight: "bold",
    textAlign: "center",
    borderRight: "1px solid black",
    boxShadow: "inset rgb(0, 0, 0) 0px -1px 0px",
    top: "0px",
  },
  optionStyle: {
    top: "0px",
    color: "white",
    fontWeight: "bold",
    backgroundColor: "#043659",
    boxShadow: "inset rgb(0, 0, 0) 0px -1px 0px",
    textAlign: "center",
  },
  pagenation: {
    backgroundColor: "#bababa",
    // boxShadow: "inset rgb(0, 0, 0) 0px 1px 0px",
    bottom: "0px",
  },
  bottomdiv: {
    bottom: "0px",
    position: "sticky",
    padding: "20px 0px 20px 10px",
    fontSize: "0.75em",
    zIndex: 999,
    // boxShadow: "inset rgb(0, 0, 0) 0px 1px 0px",
    backgroundColor: "#bababa",
  },
  bottomdivmobile: {
    position: "absolute",
    padding: "20px 20px 20px 10px",
    fontSize: "0.75em",
    zIndex: 999,
    display: 'flex',
    // boxShadow: "inset rgb(0, 0, 0) 0px 1px 0px",
    backgroundColor: "#bababa",
  },
  filterbtn: {
    zIndex: 9999,
    padding: "5px 10px",
    background: "rgb(0, 111, 176)",
    color: "white",
    fontSize: "1rem",
    borderRadius: "13px",
    marginRight: '6px'
  },
  filtermodal: {
    margin: "30px",
    marginTop: "150px",
  },
  filterdivmodal: {
    background: "#fff",
    padding: "20px",
    borderRadius: "10px",
  },
  modalContent: {
    position: "absolute",
    top: `50%`,
    left: `50%`,
    transform: `translate(-50%, -50%)`,
  },
};



// WEBPACK FOOTER //
// ./src/Pages/UnusualOptionsActivity/UOAStyles.js